/**
* @name: file-show-list
* @author: weiyong
* @date: 2024-03-23 16:28
* @description：file-show-list
* @update: 2024-03-23 16:28
*/
<template>
  <div  class="file-show-list" style="margin-top: 12px;">
    <template v-for="fileItem in fileList">
      <img-file :fileAclInfo="fileAclInfo"
                :businessId="businessId"
                @downFile="downFile"
                :style="listSty"
                @remove="removeFile"
                v-if="isImgFile(fileItem)"
                :fileItem="fileItem"/>
      <other-file :fileAclInfo="fileAclInfo"
                  :businessId="businessId"
                  @downFile="downFile"
                  :style="listSty"
                  @remove="removeFile"
                  v-else :fileItem="fileItem"/>
    </template>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "file-show-list",
});
</script>

<script lang="ts" setup>
import OtherFile from "@/components/xmFileComCtl/coms/other-file.vue";
import ImgFile from "@/components/xmFileComCtl/coms/img-file.vue";
import {useFileOperation} from "@/components/xmFileComCtl/hooks/useFileOperation";


interface Props {
  colsFile:number,
  businessId:string,
  fileAclInfo: any,
  fileList:any,
}

const props = withDefaults(defineProps<Props>(), {
  colsFile:1,
  businessId:'',
  fileList:[],
  fileAclInfo: {download: true, preview: true, delete: false, upload: true},
});

const listSty=computed(()=>{
  const sty={};
  sty['width']=`calc(${100/unref(props).colsFile}% - 12px)`;
  return sty;
})
const emits=defineEmits(['flushFileList','loading','closeLoading'])
const {downFile,isImgFile,removeFile} = useFileOperation(emits,()=>{
  emits('flushFileList');
},'',props.fileList);
</script>

<style type="text/css" lang="less">
.file-show-list{
  display: flex;
  flex-wrap: wrap;
  width:100%;

  .file-show-item{
    border-radius: 4px;
    padding:3px 12px;
    margin-right: 12px;
    width:var(--file-item-width,280px);
    border: 1px solid #dfdfdf;
    margin-bottom: 12px;
    &:hover{
      background-color: #F7F8FA;
    }
  }
}

</style>
